import { api } from '@repo/core/config';
import { Consolidation, ConsolidationParameters } from '@repo/core/models';

export const useConsolidationService = () => {
  const get = async (parameters?: string): Promise<Consolidation[]> => {
    parameters = parameters || '';
    try {
      const response = await api.get('consolidations' + parameters);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const exists = async (): Promise<boolean> => {
    try {
      const response = await api.get('consolidations/exists');
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const updateIncludedInFinancials = async (data: Consolidation[]) => {
    try {
      const response = await api.post('consolidations/updateIncludeInFinancials', data, {
        headers: { autoSave: true }
      });
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const post = async (data: ConsolidationParameters) => {
    try {
      const response = await api.post('consolidations/consolidate', data);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const refreshOpeningBalances = async (financialYearId: string) => {
    try {
      const response = await api.post('consolidations/refreshOpeningBalances', financialYearId);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const refreshLinkNumbers = async (financialYearId: string) => {
    try {
      const response = await api.post('consolidations/refreshLinkNumbers', financialYearId);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const removeClients = async (clientIds: string[]) => {
    try {
      const response = await api.post('consolidations/removeClients', clientIds);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const exportExcel = async (financialYearId: string, data: string[]) => {
    try {
      const response = await api.post(
        `cashbookEntries/exportExcel?financialYearId=${financialYearId}`,
        data ? data : null,
        { responseType: 'blob' }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    get,
    exists,
    updateIncludedInFinancials,
    post,
    refreshOpeningBalances,
    refreshLinkNumbers,
    removeClients,
    exportExcel
  };
};
